import { ReactNode } from 'react';
import * as S from './styles';

interface IProps {
  show: boolean;
  handleClose: () => void;
  children: ReactNode;
  offsetTop?: string;
  fixed?: boolean;
  title?: string;
  center?: boolean;
  style?: object;
}

/*
 * The close control is an inline `<svg>` rather than the `<ReactSVG>` that
 * fetched `/icons/fill/close.svg` and painted it `#B6B6B6`. Same reasoning as
 * `components/rowAction`: it inherits `currentColor`, so the hover state is a
 * CSS rule instead of a `beforeInjection` callback, and it costs no request.
 */
const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

const ModalApp: React.FC<IProps> = ({ show, handleClose, fixed, children, title, center, style }) => {
  return (
    <S.modalContainer className={`${fixed ? 'fixed' : 'absolute'} ${show ? 'show' : ''} ${center ? 'center' : ''}`}>
      <S.back onClick={handleClose} />
      <S.modalPaper className={`modal-paper ${show ? 'show' : ''} ${center ? 'center' : ''}`} style={style}>
        <S.closeBtn type="button" onClick={handleClose} title="Close" aria-label="Close">
          <CloseIcon />
        </S.closeBtn>
        {title && <S.title className="titl">{title}</S.title>}
        {children}
      </S.modalPaper>
    </S.modalContainer>
  );
};

export default ModalApp;
